import { call, put } from "redux-saga/effects";

import { api, queryBuilder, notify } from "services";
import { IPaginateRequest } from "interfaces/paginate-duck";
import { requestErrorHandler } from "utils";
import { PaginateBlockDatesActions } from "store/ducks/settings/block-dates";

export function* paginateBlockDatesRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      api.get,
      `/block-dates?${queryString}`
    );

    const { blockDates, pagination } = responseBody;
    yield put(PaginateBlockDatesActions.success(blockDates, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginateBlockDatesActions.failure(errorMessage));
  }
}
